export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/ReportDataAggregator.9a6be857.worker.js");
}
